import { actions, hooks } from "../global/allactions"
export let global = { hooks, actions }
